import React, { memo } from "react";
import { Descriptions } from "antd";
import { LoadStatus, LoadTimeSlotMap } from "../utils/enums";

export default memo(function ETAsDescription({
  loadStatus = null,
  loadPickupETA,
  loadPickupETATimeSlot,
  loadDropOffETA,
  loadDropOffETATimeSlot,
}) {
  return (
    <Descriptions column={{ xs: 1, sm: 1, md: 2 }} bordered>
      <Descriptions.Item label="Pickup ETA">
        {loadStatus === null
          ? "Pending..."
          : loadStatus >= LoadStatus.PickedUp && "Pickup Confirmed"}

        {loadStatus < LoadStatus.PickedUp && loadPickupETA
          ? new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "long",
              day: "2-digit",
            }).format(new Date(loadPickupETA)) +
              "\n" +
              LoadTimeSlotMap[loadPickupETATimeSlot] ?? ""
          : " "}
      </Descriptions.Item>

      <Descriptions.Item label="Drop off ETA">
        {loadStatus >= LoadStatus.Delivered && "Drop off Confirmed"}

        {loadStatus === null
          ? "Pending..."
          : loadStatus < LoadStatus.Delivered && loadDropOffETA
          ? new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "long",
              day: "2-digit",
            }).format(new Date(loadDropOffETA)) +
              "\n" +
              LoadTimeSlotMap[loadDropOffETATimeSlot] ?? ""
          : " "}
      </Descriptions.Item>
    </Descriptions>
  );
});
